import endPoint from "@/libs/endPoint/ava/Processos.endPoint";
import ApiServices from "@/services/uteis/ApiServices.js";
class ProcessosServices {
  constructor() {
    this.endPoint = endPoint;
    this.ApiServices = ApiServices;
  }
  async LoadProcessosAbertos(params = {}) {
    try {
      const url = this.endPoint.processoAberto;
      const { data } = await this.ApiServices.get(url, params);
      return data;
    } catch (error) {
      console.error("Error loading institution list:", error);
      throw error;
    }
  }
} // fim classe
export default new ProcessosServices();
